import type React from 'react';
import { getVideoDuration } from '@shared/helpers';
import type { ExerciseVideo } from '@shared/types/exercises';
import { useExerciseQuery } from '@src/api/api-hooks/exercises/useExerciseQuery.ts';
import { Loader } from '@src/library/components/common/index.ts';
import * as st from './styles.module.scss';

type Props = {
  videoId?: number;
  exerciseVideo?: ExerciseVideo;
};

export const ExerciseDuration: React.FC<Props> = ({ videoId, exerciseVideo }) => {
  const { data: exerciseFromQuery, isLoading } = useExerciseQuery({
    id: typeof exerciseVideo !== 'undefined' || !videoId ? undefined : String(videoId),
  });

  const exercise = exerciseVideo || exerciseFromQuery;

  const formatted =
    exercise && exercise.metadata ? getVideoDuration(exercise.metadata.Duration) : '00:00';

  if (exercise?.video_type === 'Y') return <></>;

  if (isLoading) {
    return <Loader />;
  }

  return exercise ? <div className={st.duration}>{formatted}</div> : 'Видео не найдено';
};
